/**
 * Simple component to udpate the page title.
 *
 * @module
 */
import * as React from 'react';
import { Helmet } from './meta';
/**
 *
 * # WithTitle
 *
 * Simple component to udpate the page title.
 *
 * This component uses <a href="https://github.com/nfl/react-helmet#readme" target="_blank" rel="noopener">React Helmet</a>.
 *
 * A web page can only set a single page title. Therefore, the last used instance of `WithTitle` in the DOM will overwrite any previous instances.
 *
 * Usage example:
 * ```javascript
 * import WithTitle from '@elevio/kb-kit/lib/components/WithTitle';
 *
 * export const MyTitleModifyingComponent: React.FC = () => {
 *   const pageTitle = 'My Component';
 *
 *   return (
 *     <WithTitle title={pageTitle}>
 *       <div>This component will change the page title to "My Component"</div>
 *     </WithTitle>
 *   );
 * };
 * ```
 */
const WithTitle = ({ title, children }) => (React.createElement(React.Fragment, null,
    React.createElement(Helmet, null,
        React.createElement("title", null, title || '')),
    children));
WithTitle.displayName = 'WithTitle';
export default WithTitle;
//# sourceMappingURL=WithTitle.js.map